import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getKnitterOrderList = createAsyncThunk(
  "get-knitter-order",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("knitter/order/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createKnitterOrder = createAsyncThunk(
  "create-knitter-order",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("knitter/order", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const getByIdKnitterOrder = createAsyncThunk(
  "edit-knitter-order",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`knitter/order/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateKnitterOrder = createAsyncThunk(
  "update-knitter-order",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/knitter/order/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteKnitterOrder = createAsyncThunk(
  "delete-knitter-order",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/knitter/order/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateKnitterOrderStatus = createAsyncThunk(
  "update-status",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(
        `/knitter/order/update-status/${id}`,
        data
      );
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const knitterOrderSlice = createSlice({
  name: "knitter-order",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getKnitterOrderList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getKnitterOrderList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.knitterOrderList ?? [];
        state.perPage = action?.payload?.data?.data?.perPage ?? 1;
        state.total = action?.payload?.data?.data?.total ?? 0;
      })
      .addCase(getKnitterOrderList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default knitterOrderSlice.reducer;
